<template>
    <div v-if="bizAuth.viewHouseGroup.hasRight" class="page-setting biz-house-group-mgt parent-frame" :class="{'fixed': listIsFixed}"  v-bind:style="{'min-height': myHeight}">
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>
                {{$route.meta.title}}
                <word-tips-hover data="快速建群：系統將幫您把相同門牌地址、同屋主、同業務且完善的房源，整併成群組，群組名稱預設為地址。" width="360px"></word-tips-hover>
            </h1>
            <div class="btn-group">
                <table-search @changeWord="setFilterWord" ></table-search>
                <div v-if="bizAuth.createHouseGroupAutomatically.hasRight" class="default-button publish" @click="createHouseGroup">
                    快速建群
                </div>
                <!-- <div class="default-btn">
                    建立群組
                </div> -->
            </div>
        </div>
        <house-group-mgt-list></house-group-mgt-list>
    </div>
</template>
<script>
import TableSearch from '@/components/widge/TableSearch.vue';
import houseGroupMgtList from '@/components/bussiness/mgtCategory/houseGroupMgt/houseGroupMgtComp.vue';
import wordTipsHover from '@/components/bussiness/widges/tips/wordTipsHover.vue';

import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            listIsFixed: false,
            myHeight: (window.innerHeight - 84) + 'px',
            isFilter: false,
        }
    },
    created (){
        
    },
    mounted () {
        this.$analyticsBiz.logEvent(this.$route.meta.title, { screen_name: this.$route.meta.title})
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        $route:{
            handler: function (val) {
                this.forceUpdate()
            },
            // immediate: true,
            deep: true
        },
        'bizAuth.viewHouseGroup.hasRight': function (val) {
            if(!val){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNoRight'})
            }
        }
    },
    methods: {
        handleScroll: function () {
            if(!this.isModalMode){
                let scrollTop = event.target.documentElement.scrollTop
                if( scrollTop >= 50){
                    document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                }else{
                    document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                    this.listIsFixed = false
                }

                if( scrollTop >= 115){
                    this.listIsFixed = true
                }
            }
        },
        createHouseGroup: function () {
            if(this.verifiedStatus === 'NORMAL'){
                this.$analyticsBiz.logEvent('快速建群', { screen_name: '快速建群'})
                this.$store.dispatch('createBizHouseGroup')
            }else{
                this.$store.dispatch('bizSetVerifiedAlarmBling', 200)
            }
            
        },
        setFilterWord: function (value) {
            // TODO
            this.$store.dispatch('setBizHouseGroupFilterWord', value)
            console.log(value)
        },
        // setFilterQuery: function (value) {
        //     // TODO
        //     console.log(value)
        // },
    },
    computed: {
        ...mapGetters({
            verifiedStatus: 'GET_BIZ_COMPANY_IS_VERIFIED',
            bizAuth: 'GET_BIZ_AUTH',
        })
    },
    components: {
        TableSearch,
        houseGroupMgtList,
        wordTipsHover
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/mgtCategory/houseGroupMgt/houseGroupMgtDefault.vue